module.exports = __webpack_public_path__ + "static/img/DK.0d6ab73d.jpg";